// import Validator  from "./Validator";
import Collection from "./Collection";

export default class Model {

    constructor( base_url ) {

        this.base_url       = base_url;
        this.response       = null;
        this.validator      = null;
        this.primaryKeyName = 'id';
    }

    load(id, onDone, onError){

        let self = this,
            url  = this.base_url + '/' + id;
        axios({

            method: 'GET',
            url:    url,
            data:   []

        }).then(function (response) {

            if( response.status ===  200 ){

                self.setOptions( response.data.data );

                if(onDone){
                    onDone( response );
                }
            }

        }).catch(function (error) {

            if(onError){
                onError(error.response);
            }

        });

        return this;
    }

    save(callback_then, callback_catch, callback_finally) {

        let self   = this,
            url    = this.base_url,
            method = 'POST';

        if(this.id){

            url   += '/' + this.id;
            method = 'PUT';
        }

        return axios({

            method: method,
            url:    url,
            data:   self.toJson(),

        }).then(function (response) {

            self.setOptions( response.data.data );

            if(typeof callback_then === 'function'){
                callback_then(response);
            }

        }).catch(function (error) {

            if(typeof callback_catch === 'function'){
                callback_catch(error);
            }

        }).finally(function(){

            if(typeof callback_finally === 'function'){
                callback_finally();
            }
        });



    }

    delete()
    {
        if (!this.getKey()) {

            return false;
        }

        let self = this;

        return axios({

            method: 'DELETE',
            url:    this.base_url + '/' + this.id,
            data:   self.toJson(),

        })
            .then(function (response) {

                if( response.status ===  200 ){
                    //self.setOptions( {} );
                }

            }).catch(function (error) {

            });

    }

    getKey()
    {
        return this.getAttribute(this.primaryKeyName);
    }

    getAttribute(key){

        return this[key];
    }

    validate(){

        if(this.validator instanceof Validator){

            return this.validator.validate(this);
        }

        return null;
    }


//////////////////////////////

    static find(id)
    {
        let obj = new this;

        return obj.load(id)
    }

    static fetch(page, url, params = {}){

        let model = this,
            self  = new this();

        if (page === undefined) {
            page = 1;
        }

        params['page'] = params['page'];

        if (url === undefined) {
            url = self.base_url;
        }

        return new Promise((resolve, reject) => {

            return axios({
                method : 'get',
                url    : url,
                params : params,
            })
                .then(function (response) {

                    if( response.status ===  200 ){

                        let    c = new Collection(),
                            data = response.data.data;

                        c.links = response.data.links;
                        c.meta  = response.data.meta;

                        c.data = model.makeCollection(data);

                        resolve(c);
                    }

                }).catch(function (error) {

                    reject(error)

                });


        });

    }

    static makeCollection(data){

        let collection = [];
        let model      = this;
        
        for(let i = 0, max = data.length; i < max; i++) {

            let x = new model(data[i]);

            collection.push( x )
        }

        return collection;
    }

}


// WEBPACK FOOTER //
// ./resources/js/models/Model.js